import * as React from "react";
import useTitleBar from "../hooks/useTitleBar.tsx";
import i18n from "../util/i18n.ts";

const FallbackGlobal = ({ error, info }: { error: Error; info?: any }) => {
	console.error(error, info);
	useTitleBar({
		title: i18n.t("common.error", { ns: "ui", defaultValue: "Error" }),
	});
	return (
		<>
			<p>{error.message}</p>
			<pre>{error.stack}</pre>
		</>
	);
};

const FallbackLocal = ({ error, info }: { error: Error; info?: any }) => {
	console.error(error, info);
	return (
		<p>
			<span className="text-danger">
				{i18n.t("common.error", { ns: "ui", defaultValue: "Error" })}:
			</span>{" "}
			{error.message}
		</p>
	);
};

class PlainErrorBoundary extends React.Component<
	{ children: any; FallbackComponent: React.ComponentType<{ error: Error; info?: any }> },
	{ error: Error | null }
> {
	constructor(props: any) {
		super(props);
		this.state = { error: null };
	}
	override componentDidCatch(error: Error, info: any) {
		this.setState({ error });
		console.error(error, info);
	}
	override render() {
		if (this.state.error) {
			const FC = this.props.FallbackComponent;
			return <FC error={this.state.error} />;
		}
		return this.props.children;
	}
}

export const ErrorBoundary = ({
	children,
	local,
}: {
	children: any;
	local?: boolean;
}) => {
	return (
		<PlainErrorBoundary FallbackComponent={local ? FallbackLocal : FallbackGlobal}>
			{children}
		</PlainErrorBoundary>
	);
};
